import { formatCurrency } from 'helpers/formatNumber';
import { fromSwiftDate } from 'helpers/swiftDateFormatter';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import classNames from 'classnames';
import {
  Icon,
  Picture,
  ContentBlockWithPicture,
  FlexContainer,
  Txt,
} from 'components';
import styles from './InventoryBlock.module.scss';

window.LUXON = DateTime;

/**
 * InventoryBlock
 *
 * @return {JSX.Element}
 */
const InventoryBlock = ({
  className,
  date,
  title,
  price,
  imageUrls = [],
  onDelete,
  onEdit,
  ...rest
}) => {
  const pictureKeyExtractor = useCallback((url) => url, []);
  const pictureRender = useCallback(
    (url) => <Picture src={url} alt="Property" />,
    []
  );

  return (
    <ContentBlockWithPicture
      className={classNames(
        styles.InventoryBlock,
        className,
        `${InventoryBlock.displayName}`
      )}
      pictures={imageUrls}
      pictureRender={pictureRender}
      pictureKeyExtractor={pictureKeyExtractor}
      horizontal
      bodyRelative
      {...rest}
    >
      {onDelete || onEdit ? (
        <FlexContainer alignCenter className={styles.ActionPanel} gapQuad>
          {onEdit ? <Icon name="edit" onClick={onEdit} /> : null}
          {onDelete ? (
            <Icon onClick={onDelete} name="close" highlight="black" />
          ) : null}
        </FlexContainer>
      ) : null}
      <FlexContainer column gapQuad flex>
        {date ? (
          <Txt caption>
            ADDED - {DateTime.fromJSDate(fromSwiftDate(date)).toLocaleString()}
          </Txt>
        ) : null}
        <Txt xx bold>
          {title}
        </Txt>
        <Txt>£{formatCurrency(price)}</Txt>
      </FlexContainer>
    </ContentBlockWithPicture>
  );
};

InventoryBlock.displayName = 'InventoryBlock';

export default observer(InventoryBlock);
